import { Component, OnInit, ViewChild } from '@angular/core';
import { AppBreadcrumbService } from '../../app.breadcrumb.service';
import { ValidateformComponent } from '../../common/validateform/validateform.component';
import { NgForm } from '@angular/forms';
import { Message } from 'primeng/api/message';
import { ActivatedRoute } from '@angular/router';
import { MemberService } from '../../services/MemberService'
import { UserService } from '../../services/UserService';
import { Location } from '@angular/common';
import { AlertService } from 'src/app/services/AlertService';
import { AccountService } from '../../services/AccountService';

@Component({
  selector: 'app-user-invite',
  templateUrl: './user-invite.component.html',
  styleUrls: ['./user-invite.component.scss'],
})
export class UserInviteComponent implements OnInit {
    @ViewChild('f', { static: true }) inviteUserForm: NgForm;
    @ViewChild(ValidateformComponent, { static: true })
    private formValidator: ValidateformComponent;
    user: any;   
    options: any;
    msgs: Message[];
    parentOfficeOptions: any[] = [];
    roleOptions: any[] = [];
    appRoleOptions: any[] = [];
    childOffices: any[] = [];
    selectedChildOffices: any[] = [];
    hasChildOffices: boolean = false;
    selectedAppRoles: any[] = [];
    inviteSuccess: boolean = false;
    enableOfficeManagerRole: boolean = false;    

    constructor(private breadcrumbService: AppBreadcrumbService,
                private activatedRoute: ActivatedRoute,
                private memberService: MemberService,
                private userService: UserService,
                private location: Location,
                private alertService: AlertService,
                private accountService: AccountService) { }

    ngOnInit(): void {       
        this.breadcrumbService.setItems([
            this.breadcrumbService.user,
            this.breadcrumbService.userInvite,
        ]);       
        this.options = this.activatedRoute.snapshot.data['options'];
        this.initializeVariables();
        this.parseOptions();
        this.initForm();
        this.accountService.CanEditProfile(null).subscribe(canEdit => {
            this.enableOfficeManagerRole = canEdit;
        });

    }

    parseOptions() {
        this.parentOfficeOptions = new Array();
        for (let o of this.options[0]) {
            let l = o.Name;
            this.parentOfficeOptions.push({ label: l, value: o.Id });
        }

        this.roleOptions = this.options[1];
        for (var role of this.roleOptions) {
            switch (role.Id) {
                case 1: { role.ToolTip = 'BY NOT CHECKING THIS BOX, THIS PROFILE WILL NOT APPEAR ON WWW.NAIGLOBAL.COM'; break; }
                case 2: { role.ToolTip = 'MAIN POC FOR YOUR FIRM TO HANDLE ALL DEAL FLOW'; break; }
                case 4: { role.ToolTip = 'ALL PROFESSIONAL STAFF SHOULD BE CHECKED OFF'; break; }
                case 5: { role.ToolTip = 'MAIN POC FOR MEETINGS AND COMMUNICATIONS'; break; }
                case 6: { role.ToolTip = 'PRINCIPAL, DIRECTOR OR MANAGER - ALL OWNERS OR BROKER MANAGERS SHOULD BE CHECKED OFF'; break; }
                case 7: { role.ToolTip = 'ALL ACTIVE AGENTS/BROKERS SHOULD BE CHECKED OFF'; break; }              
            } 
        }

        this.appRoleOptions = this.options[2];
        for (var role of this.appRoleOptions) {
            if (role.Name == 'admin')
                role.Description = 'NAI Global Staff';
            if (role.Name == 'officemanager')
                role.Description = 'Office Manager';
            if (role.Name == 'user') {
                role.Description = 'User';
            }
            if (role.Name == 'editownprofile') {
                role.Description = 'Allowed to edit own profile';
            }
        }          
    }

    initializeVariables() {
        this.parentOfficeOptions = [];
        this.roleOptions= [];
        this.appRoleOptions = [];
        this.childOffices = [];
        this.selectedChildOffices = [];
        this.hasChildOffices = false;
        this.selectedAppRoles = [];
        this.user = {};
    }

    initForm() {
        for (var role of this.appRoleOptions) {
            if (role.Name == 'user' || role.Name == 'editownprofile') {
                this.selectedAppRoles.push(role);
            }
        }
        this.user = { FName: '', LName: '', Email: '', Title: '', DirectPhone: '', DirectPhoneExtn: '', CellPhone: '', Fax: '', MyPropertyListings: '', ParentOfficeId: 360 };
        this.onParentOfficeChange();
    }

    inviteUser() {                     
        if (this.selectedChildOffices == undefined || this.selectedChildOffices.length == 0) {
            this.inviteUserForm.form.controls['groupChildOffices'].setErrors({ 'required': true });
        }

        if (this.selectedChildOffices != undefined && this.selectedChildOffices.length > 0) {
            for (var office of this.selectedChildOffices) {
                var ctrlName = office.Id + 'groupRoles';
                if (office.selectedRoles == undefined || office.selectedRoles.length == 0) {
                    this.inviteUserForm.form.controls[ctrlName].setErrors({ 'required': true });
                }
            }
        }
       
        if (this.formValidator.validateForm()) {
            this.user.AspNetRoles = this.selectedAppRoles;
            this.user.Offices = this.selectedChildOffices;
            this.userService.addUser(this.user).subscribe(
                result => {
                    if (result.Id != null && result.Id > 0) {
                        var message = result.FName + ' ' + result.LName + ' is invited.'
                        this.alertService.SetMessage('success', message);
                        this.inviteSuccess = true;                    
                    }
                    else {
                        this.alertService.SetMessage('error', 'There is an error while inviting new user');
                    }                  
                },
                error => {
                    if (error.includes('is already registered in the system'))
                        this.alertService.SetMessage('error', 'A user with this email address is already registered in the system');
                    else if(error.includes('Invite User ERROR'))
                        this.alertService.SetMessage('error', 'There is an error while inviting new user');
                    else{//handle timeout due to sendgrid
                        this.alertService.SetMessage('success', 'Your request is being processed, please check later if the user has been added by using the search functionality');
                        this.inviteSuccess = true;
                    }
                }
            );
        }
    }

    cancelInvite() {
        this.location.back();
    }

    onParentOfficeChange() {
        this.childOffices = [];
        this.selectedChildOffices = [];
        if (this.user.ParentOfficeId != undefined && this.user.ParentOfficeId > 0) {
            this.memberService.GetChildOfficesByParentOfficeId(this.user.ParentOfficeId).subscribe(
                result => {
                    this.childOffices = result;
                    if (this.childOffices != undefined && this.childOffices.length > 1)
                        this.hasChildOffices = true;
                    else {
                        this.hasChildOffices = false;
                        if (this.childOffices != undefined && this.childOffices.length == 1) {
                            this.selectedChildOffices = this.childOffices;
                        }
                    }                        
                },
                error => {
                    this.alertService.SetMessage('error', 'There is an error while getting child offices!');
                }
            );
        }       
    }

    showRoles(officeId) {
        if (this.selectedChildOffices != undefined && this.selectedChildOffices.length > 0) {
            for (var office of this.selectedChildOffices) {
                if (office.Id == officeId)
                    return true;
            }
        }
        return false;
    }

    onChildOfficesChange(event, officeId) {
        if (event.checked) {
            for (var office of this.selectedChildOffices) {
                if (office.Id == officeId) {
                    office.selectedRoles = [];
                }
            }
        }
    }
}
